import { render, staticRenderFns } from "./TemplateCollectionList.vue?vue&type=template&id=6363c4a3"
import script from "./TemplateCollectionList.vue?vue&type=script&lang=js"
export * from "./TemplateCollectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports